import { badgeColors } from 'constants/colors'

export const USER_GROUP_ROLES = {
  WORKER: 0,
  MANAGER: 1,
  MANAGER_AVATAR: 2,
}

export const USER_PERMISSIONS = {
  VIEW: 1,
  EDIT: 2,
  APP_ADMIN: 3,
}

export const getRoleBadgeProps = (role?: number) => {
  switch (role) {
    case USER_GROUP_ROLES.WORKER:
      return badgeColors.green
    case USER_GROUP_ROLES.MANAGER:
      return badgeColors.blue
    case USER_GROUP_ROLES.MANAGER_AVATAR:
      return badgeColors.violet
    default:
      return {
        text: 'gray.600',
        background: 'gray.100',
        border: 'gray.300',
      }
  }
}

export const getRoleName = (role?: number) => {
  switch (role) {
    case USER_GROUP_ROLES.WORKER:
      return 'Worker'
    case USER_GROUP_ROLES.MANAGER:
      return 'Manager'
    case USER_GROUP_ROLES.MANAGER_AVATAR:
      return 'Manager Avatar'
    default:
      return ''
  }
}
